function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "28px",
    height: "36px",
    viewBox: "0 0 28 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(60.784314%,60.784314%,60.784314%)",
      fillOpacity: 1
    },
    d: "M 1.554688 12.253906 L 21.777344 12.253906 L 21.777344 33.703125 C 21.777344 34.972656 20.734375 36 19.445312 36 L 3.890625 36 C 2.601562 36 1.554688 34.972656 1.554688 33.703125 Z M 1.554688 12.253906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 5.445312 22.210938 L 7 22.210938 L 7 32.171875 L 5.445312 32.171875 Z M 5.445312 22.210938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 10.890625 19.148438 L 12.445312 19.148438 L 12.445312 32.171875 L 10.890625 32.171875 Z M 10.890625 19.148438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 16.332031 15.320312 L 17.890625 15.320312 L 17.890625 32.171875 L 16.332031 32.171875 Z M 16.332031 15.320312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(60.784314%,60.784314%,60.784314%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 9.498698 22.498326 L 16.50076 22.498326 C 17.602322 22.498326 18.499891 23.397321 18.499891 24.502232 C 18.499891 25.602121 17.602322 26.501116 16.50076 26.501116 L 9.498698 26.501116 C 8.397135 26.501116 7.499566 25.602121 7.499566 24.502232 C 7.499566 23.397321 8.397135 22.498326 9.498698 22.498326 Z M 9.498698 22.498326 ",
    transform: "matrix(0.000000000000000048,-0.765957,0.777778,0.000000000000000047,-11.666667,22.978723)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(60.784314%,60.784314%,60.784314%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 15.502496 19.5 L 22.499457 19.5 C 23.60612 19.5 24.498589 20.393973 24.498589 21.498884 C 24.498589 22.603795 23.60612 23.497768 22.499457 23.497768 L 15.502496 23.497768 C 14.395833 23.497768 13.498264 22.603795 13.498264 21.498884 C 13.498264 20.393973 14.395833 19.5 15.502496 19.5 Z M 15.502496 19.5 ",
    transform: "matrix(0.000000000000000048,-0.765957,0.777778,0.000000000000000047,-4.666667,25.276596)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(60.784314%,60.784314%,60.784314%)",
      fillOpacity: 1
    },
    d: "M 3.5 4.597656 L 19.832031 4.597656 C 21.765625 4.597656 23.332031 6.140625 23.332031 8.042969 C 23.332031 9.945312 21.765625 11.488281 19.832031 11.488281 L 3.5 11.488281 C 1.566406 11.488281 0 9.945312 0 8.042969 C 0 6.140625 1.566406 4.597656 3.5 4.597656 Z M 3.5 4.597656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(60.784314%,60.784314%,60.784314%)",
      fillOpacity: 1
    },
    d: "M 11.667969 5.363281 L 11.667969 3.828125 C 11.667969 1.714844 13.40625 0 15.554688 0 C 17.703125 0 19.445312 1.714844 19.445312 3.828125 L 19.445312 5.363281 C 19.445312 7.476562 17.703125 9.191406 15.554688 9.191406 C 13.40625 9.191406 11.667969 7.476562 11.667969 5.363281 Z M 11.667969 5.363281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(60.784314%,60.784314%,60.784314%)",
      fillOpacity: 1
    },
    d: "M 5.445312 6.894531 L 5.445312 5.363281 C 5.445312 3.246094 7.1875 1.53125 9.332031 1.53125 C 11.480469 1.53125 13.222656 3.246094 13.222656 5.363281 L 13.222656 6.894531 C 13.222656 9.007812 11.480469 10.722656 9.332031 10.722656 C 7.1875 10.722656 5.445312 9.007812 5.445312 6.894531 Z M 5.445312 6.894531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(60.784314%,60.784314%,60.784314%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 28.998884 20.001519 L 30.997768 20.001519 C 33.207589 20.001519 35.000558 21.791558 35.000558 23.999783 L 35.000558 35.000109 C 35.000558 37.208333 33.207589 38.998372 30.997768 38.998372 L 28.998884 38.998372 ",
    transform: "matrix(0.777778,0,0,0.765957,0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeer);
export default __webpack_public_path__ + "static/media/beer.9629cfbbb5460756ec5ae941672dd755.svg";
export { ForwardRef as ReactComponent };